import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import PinModal from "components/__new/common/PinModal";
import { toast } from "react-toastify";
import Maybe from "components/__new/common/Maybe";
import useLoginInfo from "hooks/useLoginInfo";
import ModalAlert from "components/__new/common/ModalAlert";
import maskEmailAddress from "utils/maskData";
import useAccessPinStatus from "hooks/useAccessPinStatus";
import * as walletAction from "store/entities/wallet/action";
import TransferDestinationModal from "components/__new/payments/instant-transfers/TransferDestinationModal";
import useInlinePageRouter from "components/__new/general/useInlinePageRouter";
import EarnipayTransferType from "components/__new/payments/instant-transfers/earnipay/EarnipayTransferType";
import EarnipayBulkUploadReviewModal from "components/__new/payments/instant-transfers/earnipay/bulkTransfer/EarnipayBulkUploadReviewModal";
import BankTransferType from "components/__new/payments/instant-transfers/bankAccount/BankTransferType";
import BankBulkUploadReviewModal from "components/__new/payments/instant-transfers/bankAccount/bulkTransfer/BankBulkUploadReviewModal";
import EarnipayMultipleTransferAmountSetup from "components/__new/payments/instant-transfers/earnipay/multipleTransfer/EarnipayMultipleTransferAmountSetup";
import { ReactComponent as IconEarnipay } from "assets/images/icons/project-icons/earnipay-green-bg.svg"
import { ReactComponent as IconBank } from "assets/images/icons/project-icons/bank-transfer.svg"
import {
    clearBankTransferPreviewItems,
    clearEarnipayPreviewItems,
    createTransferBeneficiaryMultiple,
    createTransferBeneficiary,
    initiateBulkBankTransfer,
    initiateBulkEarnipayTransfer,
    initiateMultipleBankTransfer,
    initiateMultipleEarnipayTransfer,
    initiateSingleBankTransfer,
    initiateSingleEarnipayTransfer, 
    resetTransferProperties,
    resetEarnipayTransfer,
    bankTransferReset,
} from "store/entities/transfers/action";
import { postRequestComment, resetPostRequestComment } from 'store/entities/approvals/action';
import BankMultipleTransferAmountSetup from "components/__new/payments/instant-transfers/bankAccount/multipleTransfer/BankMultipleTransferAmountSetup";
import InstantTransfersTable from "components/__new/payments/instant-transfers/InstantTransfersTable";
import processParams from "utils/processParams";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import { useLocation } from "react-router-dom";
import TransferDetailsModal from "components/__new/payments/instant-transfers/TransferDetailsModal";
import * as notificationAction from 'store/entities/notification/action'
import { WorkflowType } from "utils/workflowType";
import { checkWorkflow } from "utils/checkWorkflow";
import { TransactionSummary } from "./TransactionSummary";
import FormDrawer from "components/__new/common/form-drawer";
import Textarea from 'components/__new/common/form/Textarea';
import { ButtonLoader } from "components/__new/common/form";
import { REGEX_VALUES } from "utils/regexValues";
import useBanks from "hooks/useBanks";


export const InstantTransfers = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const {userInfo} = useLoginInfo();
    const {getAccessPinStatus} = useAccessPinStatus();
    const { InlineRouterTab } = useInlinePageRouter();
    const {urlQueryParams} = useUrlQueryParams();
    const { dashboardLoading, dashboard, otpGenerationLoading, otpGeneration, accessPinLoading, accessPin, resetPin } = useSelector((s) => s.entities.wallet);    
    const { bankTransferResponse, earnipayTransferResponse, earnipayTransferLoading, bankTransferLoading, earnipayTransferFailed, bankTransferFailed } = useSelector((state) => state.entities.transfers)
    const { requestCommentLoading, requestComment } = useSelector((state) => state.entities.approvals);
    const { banks, banksLoading } = useBanks(userInfo?.token);
    
    const bankTransferTabItems = [
        { title: "Single Transfer", value: WorkflowType.TRANSFER_REQUEST },
        { title: "Multiple Transfers", value: WorkflowType.MULTIPLE_TRANSFER_REQUEST },
        { title: "Bulk Upload", value: WorkflowType.BULK_TRANSFER, disabled: true, }
    ]
    const earnipayTransferTabItems = [
        { title: "Single Transfer", value: WorkflowType.TRANSFER_REQUEST },
        { title: "Multiple Transfers", value: WorkflowType.MULTIPLE_TRANSFER_REQUEST  },
        { title: "Bulk Upload", value: WorkflowType.BULK_TRANSFER, disabled: true,  }
    ]
    const [alias, setAlias] = useState("")
    
    const [transferDestination, setTransferDestination] = useState("");
    
    const transferTypes = [
        {
            title: "To Earnipay Account",
            subtitle: "This allows you to send money to an Earnipay account",
            Icon: IconEarnipay,
            value: "earnipay",
        },
        {
            title: "To Bank Account",
            subtitle: "This allows you to send money to a bank account",
            Icon: IconBank,
            value: "bank",
        },
    ]
    
    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 20,
    });
    
    const [transferType, setTransferType] = useState(WorkflowType.TRANSFER_REQUEST);
    
    const [isOpenOtpNewPin, setIsOpenOtpNewPin] = useState(false);
    const [isOpenAccessPin, setIsOpenAccessPin] = useState(false);
    const [isOpenNewAccessPin, setIsOpenNewAccessPin] = useState(false);
    
    const [transferPayload, setTransferPayload] = useState(null);
    
    const [isOpenConfirmAccessPin, setIsOpenConfirmAccessPin] = useState(false);
    const [isOpenModalAlertTransferSuccess, setIsOpenModalAlertTransferSuccess] = useState(false);
    const [isOpenModalAlertNewPinSuccess, setIsOpenModalAlertNewPinSuccess] = useState(false);
    
    const [isOpenTransferDestination, setIsOpenTransferDestination] = useState(false);
    const [isOpenEarnipayTransfer, setIsOpenEarnipayTransfer] = useState(false);
    
    const [isOpenBankTransfer, setIsOpenBankTransfer] = useState(false);
    const [isEarnipayBulkReviewOpen, setIsEarnipayBulkReviewOpen] = useState(false);
    const [isBankBulkReviewOpen, setIsBankBulkReviewOpen] = useState(false);
    
    const [isEarnipayMultipleTransferAmountOpen, setIsEarnipayMultipleTransferAmountOpen] = useState(false);
    const [earnipayPreviewItems, setEarnipayPreviewItems] = useState([]);
    
    const [bankPreviewItems, setBankPreviewItems] = useState([]);
    const [isBankMultipleTransferAmountOpen, setIsBankMultipleTransferAmountOpen] = useState(false);
    
    const [isSavingBeneficiary, setIsSavingBeneficiary] = useState(false);
    const [selectedSourceAccount, setSelectedSourceAccount] = useState(null);
    
    const [isOpenTransactionSummary, setIsOpenTransactionSummary] = useState(false);
    const toggleEarnipayTransferType = () => setIsOpenEarnipayTransfer(!isOpenEarnipayTransfer);
    const toggleBankTransferType = () => setIsOpenBankTransfer(!isOpenBankTransfer);
    const toggleTransferDestination = () => setIsOpenTransferDestination(!isOpenTransferDestination);
    
    const toggleBulkEarnipayReview = () => setIsEarnipayBulkReviewOpen(!isEarnipayBulkReviewOpen);
    const toggleBulkBankReview = () => setIsBankBulkReviewOpen(!isBankBulkReviewOpen);
    
    const toggleMultipleEarnipayTransferAmount = () => setIsEarnipayMultipleTransferAmountOpen(!isEarnipayMultipleTransferAmountOpen)
    const toggleMultipleBankTransferAmount = () => setIsBankMultipleTransferAmountOpen(!isBankMultipleTransferAmountOpen)
    
    const [pin, setPin] = useState({
        otp: "",
        accessPin: "",
        accessPinConfirm: "",
    })
    
    const [messageType, setMessageType] = useState("transfer");
    const [isRequestApprovalCommentOpen, setIsRequestApprovalCommentOpen] = useState(false);
    const [approvalComment, setApprovalComment] = useState("");
    const [createApprovalRequestData, setCreateApprovalRequestData] = useState(null);
    
    const [detailsOpen, setDetailsOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    const [isTransferLoading, setIsTransferLoading] = useState(false);
    const [recipientData, setRecipientData] = useState({});
    const [fees, setFees] = useState(0);
    
    const openTransactionDetails = (transaction) => {
        setSelected(transaction);
        setDetailsOpen(true);
    }


    const getDashboard = () => {
        if(!dashboardLoading && (Object.keys(dashboard).length === 0 || dashboard.status !== "success")){
            dispatch(walletAction.getDashboardSilent(userInfo.token));
        }
    }

    const resetPins = () => {
        setPin({ ...pin, otp: "", accessPin: "", accessPinConfirm: "" });
    }
    
    const onProceedTransfer = () => {
        setIsOpenTransactionSummary(false);
        let payload = {...transferPayload}

        if (payload.hasOwnProperty('narration') && payload.narration === '') {
            delete payload.narration;
        }

        const hasAccessPin = getAccessPinStatus();
        if (hasAccessPin === true) {
            setIsOpenAccessPin(true);
        } else {
            setIsOpenNewAccessPin(true);
        }
    }

    const initiateTransfer = (tempPayload) => {
        resetPins();
        if (transferType === WorkflowType?.BULK_TRANSFER || transferType === WorkflowType?.MULTIPLE_TRANSFER_REQUEST) {
            let payload = {...tempPayload}

            if (payload.hasOwnProperty('narration') && payload.narration === '') {
                delete payload.narration;
            }

            setTransferPayload(payload);

            const hasAccessPin = getAccessPinStatus();
            if (hasAccessPin === true) {
                setIsOpenAccessPin(true);
            } else {
                setIsOpenNewAccessPin(true);
            }
        } else {
            setTransferPayload({...tempPayload, ...recipientData, transferDestination, fees});
            setIsOpenTransactionSummary(true);
        }
    }

    const transferSuccessful = () => {
        dispatch(notificationAction.getAllNotifications()).then(() => {
            setIsTransferLoading(false);
            setIsOpenAccessPin(false);
            setIsOpenModalAlertTransferSuccess(true);
        });
    }
    
    const processTransfer = async () => {
        setIsTransferLoading(true);
        const metaData = {
            payload: {
                ...transferPayload,
                accessPin: pin.accessPin
            },
            destination: transferDestination
        }
        const data = await checkWorkflow(userInfo?.token, transferType, userInfo?.member, metaData)
        if (data.workflowExist == false) {
            await makeTransfer(transferDestination, transferType, transferPayload, pin);
        } else {
            setIsTransferLoading(false);
            setIsOpenAccessPin(false);
            setMessageType('request');
            setIsRequestApprovalCommentOpen(true);
            setCreateApprovalRequestData(data?.data?.data);
        }
    }
    
    const handleSendTransferRequestComment = () => {
        const payload = {
            comment: approvalComment,
        }
        dispatch(postRequestComment(payload, createApprovalRequestData?.id));
    }
    
    useEffect(() => {
        if (requestComment?.error === false) {
            dispatch(resetPostRequestComment());
            setCreateApprovalRequestData(null);
            setApprovalComment("");
            setIsOpenModalAlertTransferSuccess(true);
            setIsRequestApprovalCommentOpen(false);
        }
    }, [requestComment]);
    
    const makeTransfer = async (transferDestination, transferType, transferPayload, pin) => {
        if(transferDestination === 'earnipay') {
            if(transferType === WorkflowType.TRANSFER_REQUEST) {
                dispatch(initiateSingleEarnipayTransfer({
                    ...transferPayload,
                    accessPin: pin.accessPin
                }));
            } else if(transferType === WorkflowType.MULTIPLE_TRANSFER_REQUEST) {
                dispatch(initiateMultipleEarnipayTransfer({
                    ...transferPayload,
                    accessPin: pin.accessPin
                }));
            } else if(transferType === WorkflowType.BULK_TRANSFER) {
                dispatch(initiateBulkEarnipayTransfer({
                    ...transferPayload,
                    accessPin: pin.accessPin
                }));
            }
        } else if(transferDestination === 'bank') {
            if(transferType === WorkflowType.TRANSFER_REQUEST) {
                dispatch(initiateSingleBankTransfer({
                    ...transferPayload,
                    accessPin: pin.accessPin
                }));
            } else if(transferType === WorkflowType.MULTIPLE_TRANSFER_REQUEST) {
                dispatch(initiateMultipleBankTransfer({
                    ...transferPayload,
                    accessPin: pin.accessPin
                }));
            } else if(transferType === WorkflowType.BULK_TRANSFER) {
                dispatch(initiateBulkBankTransfer({
                    ...transferPayload,
                    accessPin: pin.accessPin,
                }));
            }
        }
    }
    
    const handleCreateBeneficiary = () => {
        
        if(transferDestination === 'earnipay') {
            if(transferType === WorkflowType.TRANSFER_REQUEST) {
                const payload = {
                    type: "intra",
                    accountNumber: earnipayTransferResponse?.data?.destinationAccountNumber,
                    walletId: earnipayTransferResponse?.data?.walletId,
                    accountName: earnipayTransferResponse?.data?.destinationAccountName,
                    bankName: earnipayTransferResponse?.data?.destinationBankName,
                    bankCode: earnipayTransferResponse?.data?.destinationBankCode,
                    alias: alias
                }
                dispatch(createTransferBeneficiary(payload))
                dispatch(resetTransferProperties());
            }
            // else if(transferType === WorkflowType.MULTIPLE_TRANSFER_REQUEST) {
            //     const accountNumbers = transferPayload?.beneficiaries?.map((item) => item?.accountNumber)
            //     const payload = { type: "intra", accountNumbers, }
            //     dispatch(createTransferBeneficiaryMultiple(payload))
            // }
        } else if(transferDestination === 'bank') {
            
            if(transferType === WorkflowType.TRANSFER_REQUEST) {
                const { destinationAccountName, destinationAccountNumber, destinationBankCode, destinationBankName } = bankTransferResponse?.data;

                const payload = {
                    type: "inter",
                    accountName: destinationAccountName,
                    accountNumber: destinationAccountNumber,
                    bankName: destinationBankName,
                    bankCode: destinationBankCode,
                    alias: alias
                }
                dispatch(createTransferBeneficiary(payload))
                dispatch(resetTransferProperties());
            }
            // else if(transferType === WorkflowType.MULTIPLE_TRANSFER_REQUEST) {
            //     const accountNumbers = transferPayload?.recipients?.map(({accountName, accountNumber, bankCode, bankName}) => ({
            //         accountName,
            //         accountNumber,
            //         bankName,
            //         bankCode,
            //     }))
            //     const payload = {
            //         type: "inter",
            //         accountNumbers,
            //     }
            //     dispatch(createTransferBeneficiaryMultiple(payload))
            // }
        }
        setIsSavingBeneficiary(false);
    }
    
    const getTransactions = () => {
        let params = {...listParams, product: "general", type: "debit"};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");
        params = processParams(urlQueryParams, params, "status", "string", "", "status");
        params = processParams(urlQueryParams, params, "search", "string", "", "keyword");
        params = processParams(urlQueryParams, params, "startDate", "string", "", "startDate");
        params = processParams(urlQueryParams, params, "endDate", "string", "", "endDate");

        setListParams(params);
        dispatch(walletAction.getTransactions(userInfo.token, params));
    }

    const closeTransferSummaryModal = () => {
        setIsOpenTransactionSummary(false);
        // setIsOpenTransferDestination(true)
    }

    useEffect(() => {
        getTransactions();
        // eslint-disable-next-line
    }, [location]);


    useEffect(() => {
        getDashboard();
        setIsSavingBeneficiary(false);
        setTransferType(WorkflowType.TRANSFER_REQUEST);
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (earnipayTransferResponse?.status === 'success' || earnipayTransferResponse?.error === false || bankTransferResponse?.error === false){
            transferSuccessful();
            getTransactions();
            setEarnipayPreviewItems([]);
            setBankPreviewItems([]);
            dispatch(clearEarnipayPreviewItems());
            dispatch(clearBankTransferPreviewItems());
            dispatch(resetEarnipayTransfer());
            dispatch(bankTransferReset());
            setAlias(earnipayTransferResponse?.data?.destinationAccountName || bankTransferResponse?.data?.destinationAccountName)
        }
        // eslint-disable-next-line
    }, [earnipayTransferResponse, bankTransferResponse])


    useEffect(() => {
        // if (otpGeneration?.status === "success"){
        if (otpGeneration?.error === false){
            const hasAccessPin = getAccessPinStatus(dashboard);
            if (hasAccessPin === null || hasAccessPin === false){
                setIsOpenConfirmAccessPin(false);
                setIsOpenOtpNewPin(true);
            }
            dispatch(walletAction.generateOtpReset());
        }
        // eslint-disable-next-line
    }, [otpGeneration])

   

    useEffect(() => {
        // if (accessPin?.status === "success"){
        if (accessPin?.error === false){
            setIsOpenOtpNewPin(false);
            setIsOpenModalAlertNewPinSuccess(true);
            resetPins();
            // dispatch(walletAction.createAccessPinReset());
            dispatch(walletAction.getDashboard(userInfo));
            // updateIsAccessPinSet(true);
        }
        // eslint-disable-next-line
    }, [accessPin])
    
    useEffect(() => {
        if (resetPin?.error === false) {
            setIsOpenModalAlertNewPinSuccess(true);
        }
    }, [resetPin])
    
    useEffect(() => {
        if (earnipayTransferFailed?.status === "failed") {
            dispatch(resetEarnipayTransfer());
            setIsTransferLoading(false);
        }
    }, [earnipayTransferFailed]);
    
    useEffect(() => {
        if (bankTransferFailed?.status === "failed" || bankTransferFailed?.error) {
            dispatch(bankTransferReset());
            setIsTransferLoading(false);
        }
    }, [bankTransferFailed]);


    return (
        <div>

            <DynamicHeadTag
                headerText="Instant Transfers"
            />
            
            <TransactionSummary
                isOpen={isOpenTransactionSummary}
                setIsOpen={setIsOpenTransactionSummary}
                transferPayload={transferPayload}
                onProceed={onProceedTransfer}
                closeTransferSummaryModal={closeTransferSummaryModal}
            />

            <TransferDestinationModal
                isOpen={isOpenTransferDestination}
                setIsOpen={setIsOpenTransferDestination}
                toggleEarnipayTransferType={toggleEarnipayTransferType}
                toggleBankTransferType={toggleBankTransferType}
                transferTypes={transferTypes}
                transferDestination={transferDestination}
                setTransferDestination={setTransferDestination}
                setSelectedSourceAccount={setSelectedSourceAccount}
            />
            
            <EarnipayBulkUploadReviewModal
                isOpen={isEarnipayBulkReviewOpen}
                setIsOpen={toggleBulkEarnipayReview}
                toggleEarnipayTransferType={toggleEarnipayTransferType}
                toggleBulkEarnipayReview={toggleBulkEarnipayReview}
                initiateTransfer={initiateTransfer}
            />
            
            <BankBulkUploadReviewModal
                isOpen={isBankBulkReviewOpen}
                setIsOpen={setIsBankBulkReviewOpen}
                toggleBulkBankReview={toggleBulkBankReview}
                toggleBankTransferType={toggleBankTransferType}
                initiateTransfer={initiateTransfer}
                
            />
            
            <EarnipayTransferType
                earnipayPreviewItems={earnipayPreviewItems}
                isOpen={isOpenEarnipayTransfer}
                setEarnipayPreviewItems={setEarnipayPreviewItems}
                initiateTransfer={initiateTransfer}
                setRecipientData={setRecipientData}
                onProceedTransfer={onProceedTransfer}
                setTransferType={setTransferType}
                toggleBulkEarnipayReview={toggleBulkEarnipayReview}
                earnipayTransferTabItems={earnipayTransferTabItems}
                toggleTransferDestination={toggleTransferDestination}
                toggleEarnipayTransferType={toggleEarnipayTransferType}
                toggleMultipleEarnipayTransferAmount={toggleMultipleEarnipayTransferAmount}
                selectedSourceAccount={selectedSourceAccount} 
                setSelectedSourceAccount={setSelectedSourceAccount}
            />
            
            <BankTransferType
                isOpen={isOpenBankTransfer}
                bankPreviewItems={bankPreviewItems}
                setBankPreviewItems={setBankPreviewItems}
                toggleTransferDestination={toggleTransferDestination}
                toggleBankTransferType={toggleBankTransferType}
                toggleBulkBankReview={toggleBulkBankReview}
                setTransferType={setTransferType}
                bankTransferTabItems={bankTransferTabItems}
                initiateTransfer={initiateTransfer}
                toggleMultipleBankTransferAmount={toggleMultipleBankTransferAmount}
                selectedSourceAccount={selectedSourceAccount} 
                setSelectedSourceAccount={setSelectedSourceAccount}
                setFees={setFees}
            />
            
            <Maybe condition={isEarnipayMultipleTransferAmountOpen}>
                <EarnipayMultipleTransferAmountSetup
                    earnipayPreviewItems={earnipayPreviewItems}
                    setEarnipayPreviewItems={setEarnipayPreviewItems}
                    isOpen={isEarnipayMultipleTransferAmountOpen}
                    toggleEarnipayTransferType={toggleEarnipayTransferType}
                    toggleMultipleEarnipayTransferAmount={toggleMultipleEarnipayTransferAmount}
                    initiateTransfer={initiateTransfer}
                    selectedSourceAccount={selectedSourceAccount} 
                    setSelectedSourceAccount={setSelectedSourceAccount}
                />
            </Maybe>
            
            <Maybe condition={isBankMultipleTransferAmountOpen}>
                <BankMultipleTransferAmountSetup
                    bankPreviewItems={bankPreviewItems}
                    setBankPreviewItems={setBankPreviewItems}
                    isOpen={isBankMultipleTransferAmountOpen}
                    toggleBankTransferType={toggleBankTransferType}
                    toggleMultipleBankTransferAmount={toggleMultipleBankTransferAmount}
                    initiateTransfer={initiateTransfer}
                    selectedSourceAccount={selectedSourceAccount} 
                    setSelectedSourceAccount={setSelectedSourceAccount}
                />
            </Maybe>
            
            <div className="w-full lg:w-1/2 mb-5">
                <div className="page-title flex">
                    Transfers
                </div>
            </div>
            
            <div className="flex items-center">
                <InlineRouterTab 
                    items={[
                        {
                            title: "Instant Transfers",
                            path: "/payments/transfers/instant-transfers"
                        },
                        {
                            title: "Recurring Transfers",
                            path: "#",
                            // path: "/payments/transfers/recurring-transfers",
                            disabled: true,
                            badge: 'Coming Soon' 
                        }
                    ]}
                />
            </div>

                <>

                    <PinModal
                        target="Access Pin"
                        title="Validate Transfer"
                        description="Enter Access Pin"
                        pin={(e) => setPin({...pin, accessPin: e})}
                        submit={processTransfer}
                        loading={earnipayTransferLoading || bankTransferLoading || isTransferLoading}
                        modalLoading={dashboardLoading}
                        isOpenPin={isOpenAccessPin}
                        setIsOpenPin={setIsOpenAccessPin}
                        showForgotPin={true}
                    />


                    <ModalAlert
                        successText={`${messageType === "transfer" ? "Congratulations! Your transaction was successful" : "Congratulations! Your transfer request was created successfully"}`}
                        dismissText={isSavingBeneficiary ? "Add account" : "Close"}
                        isOpenModalAlert={isOpenModalAlertTransferSuccess}
                        setIsOpenModalAlert={setIsOpenModalAlertTransferSuccess}
                        showSwitch={transferType !== 'bulk'}
                        switchTitle="Save as beneficiary"
                        switchSubtitle="You can save these details for later use"
                        onModalClose={() => isSavingBeneficiary && handleCreateBeneficiary()}
                        onSwitchChange={() => setIsSavingBeneficiary(!isSavingBeneficiary)}
                        isSwitchActive={isSavingBeneficiary}
                        hideSwitchLabel
                        messageType={messageType}
                        showInputField={isSavingBeneficiary}
                        inputFieldPlaceholder={"Enter beneficiary name"}
                        inputFieldValue={alias}
                        onInputFieldChange={(e) => setAlias(e.target.value)}
                    />


                    <PinModal
                        target="Access Pin"
                        title="Create Access Pin"
                        description="Set new access pin"
                        pin={(e) => setPin({...pin, accessPin: e})}
                        submit={() => {
                            setIsOpenNewAccessPin(false);
                            setIsOpenConfirmAccessPin(true);
                        }}
                        loading={false}
                        modalLoading={dashboardLoading}
                        isOpenPin={isOpenNewAccessPin}
                        setIsOpenPin={setIsOpenNewAccessPin}
                    />


                    <PinModal
                        target="Access Pin"
                        title="Confirm Access Pin"
                        description="Please re-enter your access pin"
                        pin={(e) => setPin({...pin, accessPinConfirm: e})}
                        submit={() => {
                            if (pin.accessPin === pin.accessPinConfirm){
                                if (userInfo.employer.userType === "employer"){
                                    dispatch(walletAction.generateOtp(userInfo.token, "access-pin"));
                                }
                                else if (userInfo.employer.userType === "employer-admin" || userInfo.employer.userType === "employer-business-member"){
                                    dispatch(walletAction.generateOtpEmployerAdmin(null, 'access-pin'));
                                }
                            }
                            else{
                                toast.error("Your access pin does not match");
                            }
                        }}
                        loading={otpGenerationLoading}
                        modalLoading={dashboardLoading}
                        isOpenPin={isOpenConfirmAccessPin}
                        setIsOpenPin={setIsOpenConfirmAccessPin}
                    />


                    <PinModal
                        target="OTP"
                        title="Enter OTP"
                        description={"Enter OTP sent to " + maskEmailAddress(userInfo?.member?.email) + ", to create your new access pin"}
                        pin={(e) => setPin({...pin, otp: e})}
                        submit={() => {
                            const params = {otp: parseInt(pin.otp), accessPin: pin.accessPin}
                            if (userInfo.employer.userType === "employer"){
                                dispatch(walletAction.createAccessPin(userInfo.token, params));
                            }
                            else if (userInfo.employer.userType === "employer-admin" || userInfo.employer.userType === "employer-business-member"){
                                dispatch(walletAction.createAccessPinEmployerAdmin(params));
                            }
                        }}
                        loading={accessPinLoading}
                        modalLoading={otpGenerationLoading}
                        isOpenPin={isOpenOtpNewPin}
                        setIsOpenPin={setIsOpenOtpNewPin}
                    />


                    <ModalAlert
                        successText={`${resetPin?.message ? resetPin?.message?.replace("Transaction pin", "Access Pin") : "Access Pin created successfully"}`}
                        dismissText="Back to transfer"
                        isOpenModalAlert={isOpenModalAlertNewPinSuccess}
                        setIsOpenModalAlert={setIsOpenModalAlertNewPinSuccess}
                        submit={() => {  
                            dispatch(walletAction.createAccessPinReset());
                            dispatch(walletAction.resetAccessPinReset());
                            setIsOpenModalAlertNewPinSuccess(false);
                            setIsOpenAccessPin(true);
                        }}
                    />
                </>

            <InstantTransfersTable
                openTransactionDetails={openTransactionDetails}
                toggleTransferDestination={toggleTransferDestination}
                loading={banksLoading}
            />
            
            <TransferDetailsModal 
                isOpen={detailsOpen}
                setIsOpen={setDetailsOpen}
                transaction={selected}
                banks={banks}
            />
            
            <FormDrawer display="center" size="lg" isOpen={isRequestApprovalCommentOpen} setIsOpen={setIsRequestApprovalCommentOpen} backdropClickable={false}>
                <div className="p-6">
                    <FormDrawer.Title
                        title="Approval Required"
                        close={setIsRequestApprovalCommentOpen}
                    />
                    <h5 className="flex items-center text-[#4A5564] font-normal leading-5 mt-2 mb-2">
                        Please note that this transaction requires approval before it can be processed
                    </h5>
                    
                    <div className="mt-6">
                        <Textarea
                            rows="7"
                            label="Add a Comment"
                            value={approvalComment}
                            placeholder='Enter a comment...'
                            onChange={(evt) => {
                                const { value } = evt.target;
                                if (value === '' || REGEX_VALUES.ALPHA_NUMERIC_WITH_HYPHEN_SPACE_AND_EXCLAMATION.test(value)) {
                                    setApprovalComment(value);
                                }
                            }}                            
                            showCharacterLength={true}
                            characterCount={approvalComment.length}
                            maxLength={150}
                            className="form-input-textarea more-padding !rounded-lg placeholder-[#9ca3af] approval-comment-text-area"
                        />
                    </div>

                    <div className="p-1 mt-4 flex items-center justify-end space-x-3 h-14">
                        <button 
                            type="button" 
                            className="btn btn-lg rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white h-full"
                            onClick={() => setIsRequestApprovalCommentOpen(false)}
                        >
                            Cancel
                        </button>
                        <ButtonLoader type="button" className="btn btn-lg rounded-lg whitespace-nowrap border text-white bg-ep-primary-600 h-full"
                            onClick={handleSendTransferRequestComment}
                            loading={requestCommentLoading}
                            disabled={approvalComment.length < 3}
                        >
                            Continue
                        </ButtonLoader>
                    </div>
                </div>
            </FormDrawer>
        </div>
    )
}


export default InstantTransfers;
